import React from "react";

export class CookiePolicyEN extends React.Component {
    render() {
        return (
            <>
                <p>
                    Last update: <b>28/11/2024</b>
                    <br />
                    <br />
                </p>
                <p>
                    This document has been prepared pursuant to EU Regulation 2016/679 (the "GDPR") to enable users to understand what cookies are installed when they use a
                    DeepUnity PACSonWEB portal (the "Website").
                </p>
                <h2>1. Data controller and data protection officer</h2>
                <p>
                    DH Healthcare GmbH, with registered office in Konrad-Zuse-Platz 1-3, 53227 Bonn, Germany, is the data controller of the personal data (the Data) of the users of
                    the Website collected using cookies. For any request it is possible to write to DH Healthcare GmbH at the above-mentioned Physical address or through the e-mail
                    address.
                    <br />
                    <br />
                    DH Healthcare GmbH has appointed a Data Protection Officer ("DPO"), who can be contacted at Dpo.belgium@dedalus.eu
                </p>
                <h2>2. Data processed by DH Healthcare GmbH</h2>
                <p>
                    The navigation on the Website involves the use of cookies, short strings of text that the websites visited send to the user's browser, where they are stored and
                    then transmitted to the same websites during subsequent visits. While browsing a site, the user may also receive cookies on their computer from sites or web
                    servers other than the one he/she is visiting (so-called "third party" cookies). It is possible to distinguish:
                    <br />
                    <br />
                    a) Technical cookies, which allow to carry out activities related to the operation of the Site.
                    <br />
                    <br />
                    b) Profiling cookies, used to analyse user behaviour and, if necessary, to send advertising messages in line with the preferences expressed by the user during
                    navigation.
                    <br />
                    <br />
                    c) Local storage, which allow to carry out activities related to the operation of the Site.
                </p>
                <p>
                    <br />
                    This Website uses the following cookies:
                </p>
                <h3>a) Technical cookies</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Host</th>
                            <th>Category</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>.ASPXAUTH</td>
                            <td>Dobco</td>
                            <td>Necessary</td>
                            <td>DeepUnity PACSonWEB portal authentication</td>
                        </tr>
                        <tr>
                            <td>ASP.NET_SessionId</td>
                            <td>Dobco</td>
                            <td>Necessary</td>
                            <td>DeepUnity PACSonWEB portal session ID</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedNecessaryCookies</td>
                            <td>Dobco</td>
                            <td>Necessary</td>
                            <td>This cookie is set if you choose to allow all cookies and registers when it was set.</td>
                        </tr>
                        <tr>
                            <td>.AspNetCore.Culture </td>
                            <td>Dobco</td>
                            <td>Necessary</td>
                            <td>Records the language choice as soon as it is changed manually</td>
                        </tr>
                        <tr>
                            <td>POWLanguage</td>
                            <td>Dobco</td>
                            <td>Necessary</td>
                            <td>Records the language choice as soon as it is changed manually (the browser language is used as a standard)</td>
                        </tr>
                        <tr>
                            <td>RETURNSCU</td>
                            <td>Dobco</td>
                            <td>Necessary</td>
                            <td>customer portal at which you logged in</td>
                        </tr>
                        <tr>
                            <td>Dobco.LocalImageCaches</td>
                            <td>Dobco</td>
                            <td>Necessary</td>
                            <td>Registers the local image caches, linked to the user</td>
                        </tr>
                        <tr>
                            <td>Dobco.ExternalLogin</td>
                            <td>Dobco</td>
                            <td>Necessary</td>
                            <td>This is used to save the state across an external login roundtrip. This is necessary for security reasons to prevent CSRF and replay attacks. The cookie will be encrypted.</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedAllCookies </td>
                            <td>Dobco</td>
                            <td>Functional</td>
                            <td>This cookie is set if you choose to allow all cookies and registers when it was set.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>b) Analytics/profiling cookies</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Host</th>
                            <th>Duration</th>
                            <th>Category</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>_GA</td>
                            <td>Google</td>
                            <td>2 years</td>
                            <td>Analytical</td>
                            <td>Used to distinguish users.</td>
                        </tr>
                        <tr>
                            <td>_GID</td>
                            <td>Google</td>
                            <td>24 hours</td>
                            <td>Analytical</td>
                            <td>Used to distinguish users.</td>
                        </tr>
                        <tr>
                            <td>_GA_&lt;container_id&gt;</td>
                            <td>Google</td>
                            <td>2 years</td>
                            <td>Analytical</td>
                            <td>Used to persist session state.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>c) Local storage (Host: Dobco; Category : Necessary)</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>cookie-shownNews</td>
                            <td> the last occasion on which you opened the notices</td>
                        </tr>
                        <tr>
                            <td>POWHomerBGuid</td>
                            <td> ID for the use of HomeReading.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3StudyTutorial</td>
                            <td> Records whether the tutorial has already been shown.</td>
                        </tr>
                        <tr>
                            <td>POW3SharingOtherDestinationSettings</td>
                            <td> Preferred settings for sharing a study.</td>
                        </tr>
                        <tr>
                            <td>printing_check_openByDefault</td>
                            <td> Preferred setting for printing an investigation.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3LoginSource</td>
                            <td> Customer portal at which you logged in.</td>
                        </tr>
                        <tr>
                            <td>cookie-acceptedPOW3Cookies</td>
                            <td> Records whether the cookie policy has already been shown.</td>
                        </tr>
                        <tr>
                            <td>ShownImportNews</td>
                            <td> Recording of the important news facts already shown.</td>
                        </tr>
                        <tr>
                            <td>Reportfontsize</td>
                            <td> Font size of the report in the viewer.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3LoginOption</td>
                            <td> How you logged in (patient / doctor).</td>
                        </tr>
                        <tr>
                            <td>cookie-uniqueBrowserIdentifier</td>
                            <td>Uniquely identifies your browser within DeepUnity PACSonWEB. It is used to determine whether you are asked to enter an OTP during logon or not.</td>
                        </tr>
                        <tr>
                            <td>cookie-last-audio-out-volume</td>
                            <td> Saves your last used audio volume out level.</td>
                        </tr>
                        <tr>
                            <td>cookie-PreferredRecognitionLanguage</td>
                            <td>Saves your preferred speech recognition language.</td>
                        </tr>
                        <tr>
                            <td>cookie-scalingFactorConfiguration</td>
                            <td>Saves your preferred scaling factor and the corresponding starting resolution.</td>
                        </tr>
                        <tr>
                            <td>cookie-dontShowPopupForNewsIds</td>
                            <td>Identifies which news item popups you do not want to see again.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    While necessary technical cookies cannot be refused by the user of the Website, as they are strictly functional to the Website itself, the user can freely
                    choose to accept or refuse the use of analytics, profiling and not strictly necessary cookies. The user can set and review their choices regarding cookies with
                    the “Change cookies setting” function available on the website (‘Legal’ section)
                </p>
                <h2>3. Purposes and legal basis of the processing</h2>
                <p>
                    By using cookies, the following purposes are pursued:
                    <br />
                    <br />
                    3.1 To enable the navigation of the Website and its smooth functionality. The legal basis for the processing is the provision to users of services related to
                    the Website and the legitimate interest of Dedalus to have a functional website.
                    <br />
                    3.2 To fulfil any obligations under applicable laws, regulations, or EU legislation, or to comply with requests from the authorities. The legal basis for the
                    processing is the obligation of Dedalus to comply with mandatory legislation.
                    <br />
                    3.3 Analyse user behaviour and possibly send him advertising messages in line with the preferences expressed by the same during navigation. The legal basis for
                    processing in this case is the consent of the interested party.
                    <br />
                    3.4 For the needs of defence of the rights of Dedalus in the context of any litigation, even in court. The legal basis of the processing is the legitimate
                    interest of the Owner to protect its rights. The conferment of Data is optional, but (except in cases of processing based on consent) the failure to provide
                    Data prevents the Controller from allowing the navigation of the Website.
                </p>
                <h2>4. Recipients of the Data</h2>
                <p>
                    The Data may be communicated:
                    <br />
                    <br />
                    (a) to third parties who need to perform specific activities in relation to the Data, in accordance with the purposes of the processing, or to service providers
                    to the Data Controller.
                    <br />
                    (b) to authorities, entities and/or parties to whom the Data must be disclosed, pursuant to binding legal or contractual provisions.
                    <br />
                    (c) in other circumstances, such as acquisitions and sales to potential third-party companies, when we expect to sell or transfer part of or all our business.
                </p>
                <h2>5. Transfer of Data outside the European Economic Area</h2>
                <p>
                    As for the possible transfer of Data to countries not belonging to the European Economic Area, the processing will take place according to one of the legally
                    permitted methods and therefore through the selection of recipients established in countries considered adequate by the European Commission or through the
                    stipulation of standard contractual clauses.
                </p>
                <h2>6. Data retention</h2>
                <p>
                    The Data will be kept only for the time necessary for the purposes for which they were collected, respecting the principles of conservation limitation and
                    minimization. More precisely, the terms of duration of the cookies are defined in the previous section 2. For the Data whose processing is based on the consent
                    of the interested party, it is specified that the same will be kept until such consent is revoked.
                </p>
                <h2>7. Data subjects’ rights</h2>
                <p>
                    In the presence of the relevant legal prerequisites, the data subject may ask the Data Controller or the DPO for access to their Data, to rectify or erase them
                    or to object to their processing, to request the restriction of processing in the cases provided for by Article 18 GDPR, as well as to obtain in a structured,
                    commonly used, and machine-readable format the data concerning him/her, in the cases provided for by Article 20 GDPR.
                    <br />
                    <br />
                    In addition, the user has the right to revoke any consent to processing at any time, without affecting the lawfulness of the processing carried out by the
                    Controller before the revocation.
                    <br />
                    <br />
                    Requests should be made in writing to the Data Controller at the addresses indicated above.
                    <br />
                    In any case, the interested party may lodge a complaint with the Guarantor for the Protection of Personal Data if he believes that the processing of his Data is
                    contrary to the regulations in force.
                </p>
            </>
        );
    }
}
